import { DropboxFilesGridView } from '@components/layout/grids';
import {
    useLazyGetRepairdocDropboxFilesLoadedPathsQuery,
    useRepairdocFavoriteMutation,
    useRepairdocUnfavoriteMutation,
} from '@repairdocs/services';
import { useCallback } from 'react';
import { defineMessage } from 'react-intl';

export const RepairdocsGridView = () => {
    const [triggerLoadedPaths] = useLazyGetRepairdocDropboxFilesLoadedPathsQuery();
    const [favoriteFile] = useRepairdocFavoriteMutation();
    const [unfavoriteFile] = useRepairdocUnfavoriteMutation();

    const loadPage = useCallback(
        async ({
            queryPath,
            pageSize,
            loadedPaths,
        }: {
            queryPath: string;
            pageSize: number;
            loadedPaths: string[];
        }) => {
            const pageData = await triggerLoadedPaths(
                {
                    path: queryPath,
                    page_size: pageSize,
                    loaded_paths: loadedPaths,
                },
                true
            ).unwrap();

            return {
                results: pageData.results ?? [],
                count: pageData.count,
            };
        },
        [triggerLoadedPaths]
    );

    const handleFavorite = useCallback(
        async ({ path, folderPath }: { path: string; folderPath: string }) => {
            await favoriteFile({ path, folderPath }).unwrap();
        },
        [favoriteFile]
    );

    const handleUnfavorite = useCallback(
        async ({ path, folderPath }: { path: string; folderPath: string }) => {
            await unfavoriteFile({ path, folderPath }).unwrap();
        },
        [unfavoriteFile]
    );

    return (
        <DropboxFilesGridView
            routeSegment="repairs"
            downloadType="repair_documents"
            loadErrorMessage={defineMessage({
                id: 'repairdocs.loadError',
                defaultMessage: 'Error loading repair documents',
            })}
            loadFailedMessage={defineMessage({
                id: 'repairdocs.loadFailed',
                defaultMessage: 'Failed to load repair documents.',
            })}
            emptyListMessage={defineMessage({
                id: 'repairdocs.noAssets',
                defaultMessage: 'No repair documents found in this folder.',
            })}
            loadPage={loadPage}
            onFavorite={handleFavorite}
            onUnfavorite={handleUnfavorite}
        />
    );
};
